import { FC, ReactElement } from 'react';
import { DefaultValues, FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod/dist/zod';

import {
  BeneficiaryFormOutput,
  BeneficiarySchema,
  beneficiarySchema,
} from '../beneficiarySchema';
import BeneficiaryFormWrapper from './BeneficiaryFormWrapper';
import RequiredFields from './RequiredFields';

interface BeneficiaryFormProps {
  beneficiary: DefaultValues<BeneficiarySchema>;
  primaryAction: {
    title: string;
    onSubmit: (formValues: BeneficiaryFormOutput) => void;
    isSending: boolean;
    isDisabled?: boolean;
  };
  secondaryAction: ReactElement;
}

const BeneficiaryForm: FC<BeneficiaryFormProps> = ({
  beneficiary,
  primaryAction,
  secondaryAction,
}) => {
  const form = useForm<BeneficiarySchema, BeneficiaryFormOutput>({
    defaultValues: beneficiary,
    resolver: zodResolver(beneficiarySchema),
  });

  return (
    <FormProvider {...form}>
      <BeneficiaryFormWrapper
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
      >
        <RequiredFields />
      </BeneficiaryFormWrapper>
    </FormProvider>
  );
};

export default BeneficiaryForm;
